import { render, staticRenderFns } from "./PaySlips.vue?vue&type=template&id=2f32b460&scoped=true&"
import script from "./PaySlips.vue?vue&type=script&lang=js&"
export * from "./PaySlips.vue?vue&type=script&lang=js&"
import style0 from "./PaySlips.vue?vue&type=style&index=0&id=2f32b460&lang=scss&scoped=true&"
import style1 from "./PaySlips.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f32b460",
  null
  
)

export default component.exports